import * as Typings from '../typings'
import { BRAND_LIST, Languages } from 'typings'

const JapanLocale: Typings.LocaleType = {
  REGION: Typings.RegionGroupNames.JAPAN,
  CODE: 'jp',
  LANGUAGE_CODE: 'ja',

  LONG_NAME: 'Japan',
  SHORT_NAME: 'JP',

  DISPLAY_NAME: '日本',
  DISPLAY_COUNTRY: '日本',

  LANGUAGES: {
    JA: 'ja',
  },

  GEO_COORDINATES: {
    INITIAL_LATITUDE: 33.92920123358008,
    INITIAL_LONGITUDE: 138.42930714999994,
    INITIAL_ZOOM: 4,
    INITIAL_ZOOM_DETAILS_PAGE: 15,
  },

  POSTCODE_FORMAT: '^〒?[0-9]{3}[- ]*[0-9]{4}$',

  [BRAND_LIST.UQ]: {
    [Languages.JA]: {
      HOME_PAGE_URL: 'https://www.uniqlo.com/jp/ja/',
      TERMS_OF_USE_URL: 'https://faq.uniqlo.com/articles/FAQ/terms',
      PRIVACY_POLICY_URL:
        'https://faq.uniqlo.com/pkb_Home?l=ja&c=category_uq%3AUQ_C6_3',
      CONTACT_US_URL: 'https://faq.uniqlo.com/',
    },
  },
  [BRAND_LIST.PL]: {
    [Languages.JA]: {
      HOME_PAGE_URL: 'https://www.plst.com/jp/ja/',
      TERMS_OF_USE_URL: 'https://faq.plst.com/articles/FAQ/100007403',
      PRIVACY_POLICY_URL: 'https://faq.plst.com/articles/FAQ/100007402',
      CONTACT_US_URL: 'https://faq.plst.com/',
    },
  },
  [BRAND_LIST.GU]: {
    [Languages.JA]: {
      HOME_PAGE_URL: 'https://www.gu-global.com/jp/ja/',
      TERMS_OF_USE_URL: 'https://faq.gu-global.com/articles/FAQ/100001768',
      PRIVACY_POLICY_URL: 'https://faq.gu-global.com/articles/FAQ/100001567/',
      CONTACT_US_URL: 'https://faq.gu-global.com/',
    },
  },

  CLIENT_ID: {
    [BRAND_LIST.UQ]: 'uq.jp.storelocator',
    [BRAND_LIST.PL]: 'pl.jp.storelocator',
    [BRAND_LIST.GU]: 'gu.jp.storelocator',
  },

  LOGO_SUFFIX: {
    [BRAND_LIST.UQ]: 'g/icons/tab_uniqlo.svg',
    [BRAND_LIST.PL]: 'g/icons/logo_plst_v2.svg',
    [BRAND_LIST.GU]: 'g/icons/tab_gu_v2.svg',
  },

  MARKER_SUFFIX: {
    [BRAND_LIST.UQ]: 'g/icons/uq_location-pin.svg',
    [BRAND_LIST.PL]: 'g/icons/plst_location-pin.svg',
    [BRAND_LIST.GU]: 'g/icons/gu_location-pin_v2.svg',
  },

  CMS_ENABLED: {
    [BRAND_LIST.UQ]: true,
    [BRAND_LIST.PL]: true,
    [BRAND_LIST.GU]: true,
  },

  PARKING_FILTER: {
    WHEELCHAIR_ACCESSIBLE_PARKING: {
      [BRAND_LIST.UQ]: true,
      [BRAND_LIST.PL]: false,
      [BRAND_LIST.GU]: true,
    },
  },

  AM_FORMAT: ' AM',
  PM_FORMAT: ' PM',

  ONE_TRUST_FOOTER: {
    [BRAND_LIST.UQ]: true,
    [BRAND_LIST.PL]: true,
    [BRAND_LIST.GU]: true,
  },
  SHOW_STORE_SERVICE_FILTER: {
    [BRAND_LIST.UQ]: true,
    [BRAND_LIST.PL]: false,
    [BRAND_LIST.GU]: false,
  },
}

export default JapanLocale
